<div [formGroup]="parent">
  <fieldset class="fieldset">
    <div [id]="question.id" class="form-group" *ngIf="checkboxData.length > 0">
      <div [id]="question.id" class="form-field d-flex" *ngFor="let data of parent.get(controlName).controls; let j = index" [formArrayName]="controlName">
        <div [formGroupName]="j" class="col-md-12 clear-all checkbox-container">
        <input (keyup.enter)="onSelectOfCheckbox($event, data)" [attr.aria-label]="data.value.value?data.value.value:none" (click)="onSelectOfCheckbox($event, data)"   type="checkbox"  aria-invalid="false" aria-required="true" [id]="data.value.id" formControlName="selected" />
          <label tabindex="-1" id="{{data.value.id + '-lbl'}}" [for]="data.value.id">
              <span class="visuallyhidden">{{data.value.value}}</span></label>
          <span class="label-span">{{data.value.value}}</span>
        </div>
        <ng-container class="label-text">
            <app-tool-tip-notification  *ngIf="question.helpText" [ngClass]="(data.value.value && data.value.value.length > 42) ? 'info-span' :'tall-info'"  
              class=" col-sm-1" [childId]="question.id" [tooltipData]="tooltipObj"  (onDisplayMobileTooltipEmitter)="displayMobileTooltipReceiver()"></app-tool-tip-notification>
        </ng-container>
      </div>
    </div>
  </fieldset>
</div>